import api from "../../service/api"
import routes from "../../service/apiRoutes"

export const getTarget = (targetId) => api.get(routes.target, { params: { target_id: targetId }, noauth: true })
export const getService = (serviceId, targetId, next = undefined) => api.get(routes.service, { params: { target_id: targetId, service_id: serviceId, next }, noauth: true })
export const getReportFiles = (reportId) => api.get(`${routes.report}files`, { params: { report_id: reportId }, noauth: true })
